export default __webpack_public_path__ + "static/media/logo-crag.6bcd627a.png";